import React from 'react'
import { Button, Dialog, DialogActions } from '@mui/material'

interface modalProps {
  isDialogOpen: boolean
  closeModal: (boolean) => void
}

export default function ConfirmQuotationModal({
  isDialogOpen,
  closeModal
}: modalProps) {
  return (
    <>
      <Dialog open={isDialogOpen} onClose={() => closeModal(false)}>
        <Button onClick={() => closeModal(true)}> Open dialog</Button>
        <DialogActions>
          <Button onClick={() => closeModal(false)}>Cancel</Button>
          <Button autoFocus onClick={() => closeModal(false)}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
